/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Laps_Row_OffInputs */

const en_ui_laps_row_off = /** @type {(inputs: Ui_Laps_Row_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laps off`)
};

const de_ui_laps_row_off = /** @type {(inputs: Ui_Laps_Row_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runden aus`)
};

/**
* | output |
* | --- |
* | "Laps off" |
*
* @param {Ui_Laps_Row_OffInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_row_off = /** @type {((inputs?: Ui_Laps_Row_OffInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Row_OffInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_row_off(inputs)
	return de_ui_laps_row_off(inputs)
});